(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4492],{

/***/ 84492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content041": function() { return /* binding */ Content041; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47696);
/* harmony import */ var _Content041_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58026);
/* harmony import */ var _Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content041 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var image = (ref1 = payload === null || payload === void 0 ? void 0 : payload.preview) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    var points = (ref2 = payload === null || payload === void 0 ? void 0 : payload.points) !== null && ref2 !== void 0 ? ref2 : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                                className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                                children: title
                            }),
                            points.map(function(param) {
                                var id = param.id, title = param.title, description = param.description;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default().point),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading5 */ .by, {
                                            color: "dark",
                                            className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["point-title"]),
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                                            value: description
                                        })
                                    ]
                                }, id);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default().preview),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                            image: image,
                            className: (_Content041_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content041);


/***/ }),

/***/ 58026:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content041_wrapper__iJ9cZ","block":"Content041_block__ovOiO","title":"Content041_title__G7wtZ","preview":"Content041_preview__wZQHS","image":"Content041_image__Pvg80","point":"Content041_point__s1AWl","point-title":"Content041_point-title__5_AJC","content":"Content041_content__ZMqV0"};

/***/ })

}]);